import service from "@/router/request";

// /**
//  * 分页查询分类
//  * @param params 查询条件
//  */
// export async function pageClassifys(params) {
//     const res = await request.get('/business/classify/page', {
//         params
//     });
//     if (res.data.code === 0) {
//         return res.data.data;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

/**
 * 查询活动列表
 * @param params 查询条件
 */
export async function eventlist(params, route) {

    const res = await service.get('/mobile/eventInfoPageList', {
        params, route
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 预添加客户
 */
export async function preAddCustomer() {
    const res = await service.get('/business/customer/preAdd');
    if (res.data.code === 0) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 获取省市区
 */
export async function getAllArea() {
    const res = await service.get('mobile/getAreaList');
    if (res.data.code === 0) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}
export async function wxShareInit(params) {
    const res = await service.get('mobile/wxShareInit',{
        params
    });
    if (res.data.code === 0) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 查询我的活动列表
 * @param params 查询条件
 */
export async function myeventlist(params, route) {

    const res = await service.get('/mobile/myEventInfoPageList', {
        params, route
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 根据id查询活动
 * @param id 活动id
 */
export async function eventInfoDetail(id, route) {
    const res = await service.get('/mobile/eventInfoDetail?id=' + id, { route });
    if (res.data.code === 0) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 根据id查询签到信息
 * @param id 活动id
 */
export async function getSignData(id) {
    const res = await service.get('/business/eventMetadataData/getDataById?id=' + id);
    if (res.data.code === 0) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 查询用户信息
 * @param params 查询条件
 */
export async function getuserinfo(params) {

    const res = await service.get('/auth/user', {
        params
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 上传头像
 */
export async function uploadphoto(data) {
    const res = await service.post('/business/alioss/ossSingleUpload', data);
    if (res.data.code === 0) {
        return res.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 修改个人信息
 */
export async function saveuserinfo(data) {
    const res = await service.post('/mobile/updateUserInfo', data);
    if (res.data.code === 0) {
        return res.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 签到
 */
export async function gosign(data) {
    const res = await service.post('/mobile/signInByQrcode', data);
    if (res.data.code === 0) {
        return res.data;
    }
    return Promise.reject(new Error(res.data.message));
}

// /**
//  * 添加分类
//  * @param data 分类信息
//  */
// export async function addClassify(data) {
//     const res = await request.post('/business/classify', data);
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 修改分类
//  * @param data 分类信息
//  */
// export async function updateClassify(data) {
//     const res = await request.put('/business/classify', data);
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 删除分类
//  * @param id 分类id
//  */
// export async function removeClassify(id) {
//     const res = await request.delete('/business/classify/' + id);
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 批量删除分类
//  * @param data 分类id集合
//  */
// export async function removeClassifys(data) {
//     const res = await request.delete('/business/classify/batch', {
//         data
//     });
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /** 2024.1.22
//  * 根据id查询分类名称
//  * @param id 分类id
//  */
// export async function getClassifyName(id) {
//     const res = await request.get('/business/customerTags/list?classifyId=' + id);
//     if (res.data.code === 0) {
//         return res.data.data;
//     }
//     return Promise.reject(new Error(res.data.message));
// }
